import { Observable } from "rxjs";

import st from "lib/utils/index";
import { AccountRepository } from "lib/repositories/index";
import { setCurrentUser } from "modules/auth/actions";
import { pushRoute } from "modules/app/actions";
import { createFormInstance } from "modules/utils/index";

export const INITIALIZE_VIEW = "auth/LoginView/INITIALIZE_VIEW";
export const INITIALIZE_MODEL = "auth/LoginView/INITIALIZE_MODEL";
export const UPDATE_MODEL = "auth/LoginView/UPDATE_MODEL";
export const VALIDATE = "auth/LoginView/VALIDATE";
export const SUBMIT = "auth/LoginView/SUBMIT";
export const FETCH_SUBMIT_START = "auth/LoginView/FETCH_SUBMIT_START";
export const FETCH_SUBMIT_SUCCESS = "auth/LoginView/FETCH_SUBMIT_SUCCESS";
export const FETCH_SUBMIT_FAILURE = "auth/LoginView/FETCH_SUBMIT_FAILURE";

export const stateSelector = (state) => state.auth.LoginView;

const formInstance = createFormInstance({
  INITIALIZE_MODEL,
  UPDATE_MODEL,
  VALIDATE,
  SUBMIT,
  FETCH_SUBMIT_START,
  FETCH_SUBMIT_SUCCESS,
  FETCH_SUBMIT_FAILURE,
  stateSelector,
  stateKey: "form",
  withSuccessAlert: false,
  withFailureAlert: false,
  updateModelAfterSubmit: false,
  mergeFailureAlertIntoErrors: true,
  validate: ({ form: { model } }, errors) => {
    errors.add(`model.email`, st.validators.presence(model.email));
    errors.add(`model.password`, st.validators.presence(model.password));
  },
  submitModel: ({
    form: {
      model: { email, password },
    },
  }) => {
    return AccountRepository.login({ email, password });
  },
});

const initialState = {
  form: formInstance.initialState,
  viewOptions: {
    redirectAfterLogin: null,
  },
};

const reducers = {
  ...formInstance.reducersMap,

  [INITIALIZE_VIEW]: (state, { viewOptions = {} }) => {
    return {
      ...initialState,
      viewOptions,
    };
  },
};

const epics = [
  ...formInstance.epics,

  (actions$, { getState }) =>
    actions$.ofType(FETCH_SUBMIT_SUCCESS).flatMap(
      ({
        model: {
          user,
          meta: { auth_token },
        },
      }) => {
        const {
          viewOptions: { redirectAfterLogin },
        } = stateSelector(getState());
        return Observable.of(setCurrentUser({ user, auth_token }), pushRoute(redirectAfterLogin || "/"));
      }
    ),
];

export function initializeView(viewOptions = {}) {
  return { type: INITIALIZE_VIEW, viewOptions };
}

export const { initializeModel, updateModel, validate, submit } = formInstance.actions;

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/auth/LoginView/index.js